import { httpClient, httpRawClient } from '@core/http-client'
import {
    type TCreateImageForm,
    type TImage,
    type TImageType,
    type TUploadPolicy,
    createImageUrl,
    deleteImageByTypeUrl,
} from '@core/api'

export const createImage = (payload: TCreateImageForm) =>
    httpClient.post(createImageUrl(), { json: payload }).json<TUploadPolicy>()

// The policy carries absolute callback URLs, so these go out on the raw client — no prefixUrl.
export const sendSucceededUploadMessage = (url: string) => httpRawClient.post(url).json<TImage>()

export const sendFailedUploadMessage = (url: string) => httpRawClient.delete(url)

export const deleteImage = ({ modelId, type }: { modelId: string; type: TImageType }) =>
    httpClient.delete(deleteImageByTypeUrl(type, modelId))
